import { render, staticRenderFns } from "./DepartmentFacts.vue?vue&type=template&id=ff872eba&scoped=true"
import script from "./DepartmentFacts.vue?vue&type=script&lang=js"
export * from "./DepartmentFacts.vue?vue&type=script&lang=js"
import style0 from "./DepartmentFacts.vue?vue&type=style&index=0&id=ff872eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff872eba",
  null
  
)

export default component.exports